import React from 'react';
import UserFormComponent from '../../components/user-form/user-form.component';
import { makeStyles } from '@mui/styles';
import { Link } from 'react-router-dom';
import routeService from '../../../../../../routes/route.service';

const useStyles = makeStyles({
  title: {
    fontSize: '20px',
    marginBottom: '20px',
  },
});

export default function UserCreateComponent() {
  const classes = useStyles();

  return (
    <div>
      <div className={classes.title}>Create new user</div>

      <UserFormComponent />

      <Link to={`${routeService.getUsersPath()}`}>Back to user overview</Link>
    </div>
  );
}
